import Vue from 'vue'
// import currency from 'currency.js'

// Vue.filter('currency', (value, currencyCode = null, precision = 2) => {
//   if (typeof value === 'undefined') {
//     return ''
//   }
//
//   let p = 0
//   const money = value.toString().split('.')
//   if (money.length > 1) {
//     p = money[1].length
//   }
//
//   if (currencyCode === 840) {
//     const USD = value => currency(value, { precision: p, symbol: '$' })
//     return USD(value).format()
//   } if (currencyCode === 116) {
//     const RIEL = value => currency(value, { precision: p, symbol: '៛' })
//     return RIEL(value).format()
//   } if (currencyCode === 764) {
//     const C = value => currency(value, { precision: p, symbol: '฿' })
//     return C(value).format()
//   } if (currencyCode === 418) {
//     const C = value => currency(value, { precision: p, symbol: '₭' })
//     return C(value).format()
//   }
//   const C = value => currency(value, { precision: p, symbol: '' })
//   return C(value).format()
// })

function isInteger(value) {
  return Math.abs(value % 1) < Number.EPSILON
}

function addThousandsSeparator(val) {
  const [integer, decimal] = val.toString().split('.')
  return decimal
    ? `${integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${decimal}`
    : integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

Vue.filter('currency', (value, currencyCode = null) => {
  if (typeof value === 'undefined') {
    return ''
  }

  let p = 0
  if (!isInteger(value)) {
    const money = value.toString().split('.')
    if (money.length > 1) {
      p = money[1].length
    }
  }

  const val = Number(value).toFixed(p)
  const formatted = addThousandsSeparator(val)

  if (currencyCode === 840) {
    return `$${formatted}`
  } if (currencyCode === 116) {
    return `${formatted}៛`
  } if (currencyCode === 764) {
    return `${formatted}฿`
  } if (currencyCode === 418) {
    return `${formatted}₭`
  }
  return formatted
})
